// File: src/components/AuthPages.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import logoImg from "../../assets/avt.png";

// --- HÀM GIẢI MÃ JWT AN TOÀN ---
const parseJwt = (token) => {
  try {
    if (!token) return null;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};


// --- 1. CÁC COMPONENT GIAO DIỆN (UI COMPONENTS) ---

const ExitModal = ({ onConfirm, onCancel }) => (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '320px', textAlign: 'center', animation: 'scaleUp 0.2s ease-out' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚪</div>
      <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Hủy xác thực?</h3>
      <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '24px' }}>Quá trình chưa hoàn tất. Bạn sẽ quay lại màn hình đăng nhập.</p>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button onClick={onCancel} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #D1D5DB', background: 'white', color: '#374151', fontWeight: '600', cursor: 'pointer' }}>Ở lại</button>
        <button onClick={onConfirm} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', background: '#EF4444', color: 'white', fontWeight: '600', cursor: 'pointer' }}>Thoát</button>
      </div>
    </div>
    <style>{`@keyframes scaleUp { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>
  </div>
);

// ✅ FIX: Nâng cấp Component OtpInput để hứng sự kiện Paste và KeyDown
const OtpInput = ({ value, onChange, onKeyDown, onPaste, onVerify, loading, onResend }) => (
  <div style={{ textAlign: 'center', animation: 'fadeIn 0.3s' }}>
    <div style={{ marginBottom: '20px', color: '#374151' }}>
      Chúng tôi đã gửi mã xác thực gồm 6 số đến email của bạn.
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '24px' }}>
      {value.map((digit, idx) => (
        <input
          key={idx}
          id={`otp-${idx}`} // Thêm ID để focus
          type="text"
          inputMode="numeric" // Gọi bàn phím số trên điện thoại
          pattern="[0-9]*"
          maxLength="2" // Tăng lên 2 để hứng lỗi Vietkey, JS sẽ cắt sau
          value={digit}
          onChange={(e) => onChange(e.target.value, idx)}
          onKeyDown={(e) => onKeyDown(e, idx)}
          onPaste={onPaste}
          style={{
            width: '45px', 
            height: '45px', 
            textAlign: 'center', 
            fontSize: '20px',
            fontWeight: '700',
            border: '2px solid #D1D5DB', 
            borderRadius: '8px', 
            outline: 'none',
            backgroundColor: '#FFFFFF', 
            color: '#111827',           
            display: 'block'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#2563EB';
            e.target.style.backgroundColor = '#F0F7FF';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#D1D5DB';
            e.target.style.backgroundColor = '#FFFFFF';
          }}
        />
      ))}
    </div>
    <PrimaryButton isLoading={loading} onClick={onVerify}>Xác thực Email</PrimaryButton>
    <div style={{ marginTop: '20px', fontSize: '14px', color: '#6B7280' }}>
      Chưa nhận được mã? <span onClick={onResend} style={{ color: '#2563EB', cursor: 'pointer', fontWeight: '600' }}>Gửi lại</span>
    </div>
  </div>
);

const Logo = () => (
  <Link to={('/')} className="flex items-center gap-3 group decoration-0">
  <div className="relative w-9 h-9 md:w-10 md:h-10 flex items-center justify-center">
    <div className="absolute inset-0 bg-blue-500/30 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    
    <img
      src={logoImg}
      alt="SkillMatch Logo"
      className="w-9 h-9 object-contain drop-shadow-md filter brightness-110 
                 transform scale-[1.3] 
                 transition-transform duration-300 
                 group-hover:scale-[1.5] group-hover:rotate-3"
    />
  </div>

  <span className="text-xl md:text-2xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-blue-700 tracking-tight transition-all duration-300 group-hover:from-blue-700 group-hover:to-indigo-600 pb-1">
    SkillMatch
  </span>
</Link>
);

const InputField = ({ label, type, placeholder, value, onChange, name, required = true }) => (
  <div style={{ marginBottom: '20px' }}>
    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>{label}</label>
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      className="global-input-field"
      style={{
        width: '100%',
        padding: '12px 16px',
        borderRadius: '8px',
        fontSize: '15px',
        backgroundColor: '#F9FAFB',
        color: '#0b0909ff'
      }}
    />
  </div>
);

const PrimaryButton = ({ children, onClick, isLoading }) => (
  <button
    onClick={onClick}
    disabled={isLoading}
    style={{
      width: '100%',
      padding: '14px',
      backgroundColor: isLoading ? '#93C5FD' : '#2563EB',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: isLoading ? 'not-allowed' : 'pointer',
      transition: 'all 0.2s',
      boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}
    onMouseOver={(e) => !isLoading && (e.target.style.backgroundColor = '#1D4ED8')}
    onMouseOut={(e) => !isLoading && (e.target.style.backgroundColor = '#2563EB')}
  >
    {isLoading ? 'Đang xử lý...' : children}
  </button>
);

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  let displayMsg = message;
  if (typeof message === 'object') {
    displayMsg = message.message || JSON.stringify(message);
  }
  return (
    <div style={{ padding: '12px', backgroundColor: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '8px', color: '#EF4444', fontSize: '14px', marginBottom: '20px' }}>
      ⚠️ {displayMsg}
    </div>
  );
};

const SuccessMessage = ({ message }) => {
  if (!message) return null;
  return (
    <div style={{ padding: '12px', backgroundColor: '#ECFDF5', border: '1px solid #10B981', borderRadius: '8px', color: '#047857', fontSize: '14px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>check_circle</span>
      {message}
    </div>
  );
};

// --- 2. LAYOUT CHUNG ---
const AuthLayout = ({ children, title, subtitle }) => (
  <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: 'white', fontFamily: '"Inter", sans-serif' }}>
    <div style={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '40px 80px' }}>
      <div style={{ maxWidth: '450px', width: '100%', margin: '0 auto' }}>
        <Logo />
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '30px', fontWeight: '800', color: '#111827', marginBottom: '12px', marginTop: '12px' }}>{title}</h2>
          <p style={{ fontSize: '16px', color: '#6B7280', lineHeight: '1.5' }}>{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
    <div style={{ flex: '1.2', backgroundColor: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: 'linear-gradient(135deg, #2563EB 0%, #1E40AF 100%)', opacity: 0.95 }}></div>
      <div style={{ position: 'relative', zIndex: 10, padding: '80px', color: 'white', maxWidth: '650px' }}>
        <h2 style={{ fontSize: '48px', fontWeight: '800', marginBottom: '24px', lineHeight: '1.1', letterSpacing: '-1px' }}>
          Tuyển dụng & Đánh giá <br /> <span style={{ color: '#93C5FD' }}>Thông minh hơn.</span>
        </h2>
        <p style={{ fontSize: '20px', opacity: 0.9, lineHeight: '1.6', marginBottom: '40px' }}>
          "SkillMatch giúp doanh nghiệp giảm 50% thời gian sàng lọc và giúp ứng viên tìm được công việc đúng với năng lực thực tế."
        </p>
      </div>
    </div>
  </div>
);

// --- 3. ROLE SELECTION ---
const RoleSelectionStep = ({ onSelectRole, onGoLogin }) => (
  <div style={{ minHeight: '100vh', backgroundColor: 'white', display: 'flex', flexDirection: 'column' }}>
    <div style={{ maxWidth: '1000px', width: '100%', margin: '0 auto', padding: '60px 20px', fontFamily: '"Inter", sans-serif', flex: 1 }}>
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <div style={{ display: 'inline-block', marginBottom: '20px' }}><Logo /></div>
        <h1 style={{ fontSize: '40px', fontWeight: '800', color: '#111827', marginBottom: '16px' }}>Tham gia SkillMatch</h1>
        <p style={{ fontSize: '18px', color: '#6B7280' }}>Chọn vai trò của bạn để bắt đầu hành trình.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '30px', maxWidth: '800px', margin: '0 auto' }}>
        <div onClick={() => onSelectRole('candidate')} className="role-card" style={{ padding: '40px', borderRadius: '20px', border: '2px solid #E5E7EB', cursor: 'pointer', transition: 'all 0.2s', backgroundColor: 'white', textAlign: 'center' }}>
          <div style={{ width: '80px', height: '80px', background: '#EFF6FF', borderRadius: '50%', margin: '0 auto 24px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px' }}>🎓</div>
          <h3 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '12px', color: '#1F2937' }}>Tôi là Ứng viên</h3>
          <p style={{ color: '#6B7280', lineHeight: '1.5' }}>Tìm việc làm, thi kỹ năng và xây dựng hồ sơ năng lực.</p>
        </div>

        <div onClick={() => onSelectRole('business')} className="role-card" style={{ padding: '40px', borderRadius: '20px', border: '2px solid #E5E7EB', cursor: 'pointer', transition: 'all 0.2s', backgroundColor: 'white', textAlign: 'center' }}>
          <div style={{ width: '80px', height: '80px', background: '#ECFDF5', borderRadius: '50%', margin: '0 auto 24px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px' }}>🏢</div>
          <h3 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '12px', color: '#1F2937' }}>Tôi là Doanh nghiệp</h3>
          <p style={{ color: '#6B7280', lineHeight: '1.5' }}>Đăng tin tuyển dụng, tạo bài test và tìm kiếm nhân tài.</p>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <p style={{ color: '#6B7280', fontSize: '16px' }}>
          Đã có tài khoản? <span onClick={onGoLogin} style={{ color: '#2563EB', fontWeight: '600', cursor: 'pointer', textDecoration: 'underline' }}>Đăng nhập ngay</span>
        </p>
      </div>
      <style>{`.role-card:hover { border-color: #2563EB !important; transform: translateY(-5px); box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); }`}</style>
    </div>
  </div>
);

// --- 4. LOGIC CHÍNH ---

export default function AuthPages() {
  const navigate = useNavigate();
  const location = useLocation();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  // --- STATE ---
  const [successMsg, setSuccessMsg] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [isVerifying, setIsVerifying] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [verifyEmail, setVerifyEmail] = useState('');

  const [formData, setFormData] = useState({ email: '', password: '', fullName: '', companyName: '' });
  const [showExitModal, setShowExitModal] = useState(false);

  // Init Step
  const getInitialState = () => {
    const path = location.pathname;
    if (path === '/register-business') return { step: 'register', role: 'business' };
    if (path === '/register-candidate') return { step: 'register', role: 'candidate' };
    if (path === '/register-select') return { step: 'select', role: null };
    return { step: 'login', role: null };
  };
  const [currentStep, setCurrentStep] = useState(getInitialState().step);
  const [selectedRole, setSelectedRole] = useState(getInitialState().role);

  // --- UTILS ---
  const clearMessages = () => {
    setError(null);
    setSuccessMsg(null);
  };

  // ✅ FIX: Logic thay đổi khi nhập hoặc gõ từ bàn phím
  const handleOtpChange = (val, index) => {
    // Chỉ lấy số
    const numericVal = val.replace(/[^0-9]/g, '');
    if (!numericVal && val !== '') return;

    const newOtp = [...otp];
    // Lấy ký tự cuối cùng để fix lỗi đệm chữ double của Vietkey/Unikey
    newOtp[index] = numericVal.slice(-1);
    setOtp(newOtp);

    // Focus tự động nhảy sang ô tiếp theo
    if (numericVal && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  // ✅ FIX: Bấm phím Backspace nhảy ngược về ô trước
  const handleOtpKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  // ✅ FIX: Bắt sự kiện Paste để dán nguyên dãy 6 số một lúc
  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 6);
    if (!pastedData) return;

    const newOtp = [...otp];
    for (let i = 0; i < pastedData.length; i++) {
      newOtp[i] = pastedData[i];
    }
    setOtp(newOtp);

    // Di chuyển con trỏ tới ô trống tiếp theo hoặc ô cuối cùng
    const focusIndex = Math.min(pastedData.length, 5);
    const focusInput = document.getElementById(`otp-${focusIndex}`);
    if (focusInput) focusInput.focus();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    clearMessages();
  };

  const handleSendOtp = async (email) => {
    try {
      if (loading) return;
      clearMessages();
      setLoading(true);

      await fetch(`${apiBaseUrl}/api/auth/send-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      setSuccessMsg(`Mã OTP mới đã được gửi tới ${email}`);
    } catch (err) {
      setError("Không thể gửi OTP. Vui lòng thử lại sau.");
    } finally {
      setLoading(false);
    }
  };

  const navigateBasedOnRole = (user) => {
    if (user.role === 'admin') {
      navigate('/admin/dashboard', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  // --- EFFECT ---
  useEffect(() => {
    const token = localStorage.getItem('skillmatch_token');
    if (token) {
      const decoded = parseJwt(token);
      if (decoded && decoded.user) {
        if (decoded.user.isVerified) {
          if (decoded.user.isProfileCompleted) {
            navigateBasedOnRole(decoded.user);
          } else {
            navigate('/onboarding');
          }
        } else {
          setVerifyEmail(decoded.user.email);
          setIsVerifying(true);
        }
      }
    }
  }, [navigate]);

  useEffect(() => {
    if (isVerifying) {
      window.history.pushState(null, null, window.location.pathname);
      const handlePopState = () => {
        window.history.pushState(null, null, window.location.pathname);
        setShowExitModal(true);
      };
      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, [isVerifying]);

  useEffect(() => {
    const state = getInitialState();
    setCurrentStep(state.step);
    setSelectedRole(state.role);
    setIsVerifying(false);
    setShowExitModal(false);
    setOtp(['', '', '', '', '', '']);
    clearMessages();
  }, [location.pathname]);

  // --- HANDLERS ---
  const handleConfirmExit = () => {
    localStorage.removeItem('skillmatch_token');
    setIsVerifying(false);
    setShowExitModal(false);
    clearMessages();
    setFormData({ email: '', password: '', fullName: '', companyName: '' });
    navigate('/login');
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        clearMessages();
        setLoading(true);
        const userInfoRes = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const userInfo = await userInfoRes.json();

        const res = await fetch(`${apiBaseUrl}/api/auth/google-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: userInfo.email, name: userInfo.name, googleId: userInfo.sub, picture: userInfo.picture }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message);

        localStorage.setItem('skillmatch_token', data.token);
        const decoded = parseJwt(data.token);
        
        if (decoded.user.isVerified) {
          if (decoded.user.isProfileCompleted) {
            navigateBasedOnRole(decoded.user);
          } else {
            navigate('/onboarding');
          }
        } else {
          setVerifyEmail(decoded.user.email);
          await handleSendOtp(decoded.user.email);
          setIsVerifying(true);
          setSuccessMsg("Đăng nhập Google thành công! Vui lòng xác thực email.");
        }
      } catch (error) {
        setError("Đăng nhập Google thất bại.");
      } finally { setLoading(false); }
    },
    onError: () => setError("Đăng nhập Google thất bại."),
  });

  const validateInput = () => {
    if (!formData.email || !formData.password) return "Vui lòng điền đầy đủ thông tin.";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) return "Địa chỉ Email không hợp lệ.";
    if (formData.password.length < 6) return "Mật khẩu phải có ít nhất 6 ký tự.";
    if (selectedRole === 'business' && (!formData.fullName || !formData.companyName)) return "Vui lòng nhập tên người đại diện và tên công ty.";
    return null;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const errorMsg = validateInput();
    if (errorMsg) return setError(errorMsg);

    clearMessages();
    setLoading(true);

    const endpoint = selectedRole === 'business' ? '/api/auth/register-business' : '/api/auth/register';
    const bodyData = {
      email: formData.email,
      password: formData.password,
      ...(selectedRole === 'business' && { fullName: formData.fullName, companyName: formData.companyName })
    };

    try {
      const response = await fetch(`${apiBaseUrl}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message);

      setVerifyEmail(formData.email);
      await handleSendOtp(formData.email);
      setIsVerifying(true);
      setSuccessMsg("Đăng ký thành công! Vui lòng kiểm tra email để lấy OTP.");

    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    clearMessages();
    setLoading(true);
    try {
      const response = await fetch(`${apiBaseUrl}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: formData.email, password: formData.password }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Đăng nhập thất bại');

      localStorage.setItem('skillmatch_token', data.token);
      const decoded = parseJwt(data.token);

      if (decoded?.user?.isProfileCompleted) {
        navigateBasedOnRole(decoded.user);
      } else {
        navigate('/onboarding');
      }

    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  const handleVerifyOtp = async () => {
    const otpValue = otp.join('');
    if (otpValue.length < 6) return setError("Vui lòng nhập đủ 6 số");

    clearMessages();
    setLoading(true);

    const token = localStorage.getItem('skillmatch_token');

    try {
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['x-auth-token'] = token;

      const res = await fetch(`${apiBaseUrl}/api/auth/verify-otp`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ email: verifyEmail, otp: otpValue })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Mã OTP không đúng");

      localStorage.setItem('skillmatch_token', data.token);
      const decoded = parseJwt(data.token);
      if (decoded?.user?.isProfileCompleted) {
        navigateBasedOnRole(decoded.user);
      } else {
        navigate('/onboarding');
      }
    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  // --- RENDER ---
  const goRegisterSelect = () => navigate('/register-select');
  const goLogin = () => navigate('/login');
  const goRegisterForm = (role) => {
    if (role === 'business') navigate('/register-business');
    else navigate('/register-candidate');
  };

  // Màn hình chọn Role
  if (currentStep === 'select') {
    return <RoleSelectionStep onSelectRole={goRegisterForm} onGoLogin={goLogin} />;
  }

  // Màn hình Login
  if (currentStep === 'login') {
    return (
      <AuthLayout title="Chào mừng trở lại!" subtitle="Đăng nhập để tiếp tục hành trình phát triển sự nghiệp của bạn.">
        {showExitModal && <ExitModal onConfirm={handleConfirmExit} onCancel={() => setShowExitModal(false)} />}
        {isVerifying ? (
          <>
            <ErrorMessage message={error} />
            <SuccessMessage message={successMsg} />
            {/* ✅ Đã thêm props onKeyDown và onPaste */}
            <OtpInput value={otp} onChange={handleOtpChange} onKeyDown={handleOtpKeyDown} onPaste={handleOtpPaste} onVerify={handleVerifyOtp} loading={loading} onResend={() => handleSendOtp(verifyEmail)} />
          </>
        ) : (
          <>
            <form onSubmit={handleLogin}>
              <SuccessMessage message={successMsg} />
              <ErrorMessage message={error} />
              <InputField label="Email" type="email" name="email" placeholder="name@example.com" value={formData.email} onChange={handleChange} />
              <InputField label="Mật khẩu" type="password" name="password" placeholder="Nhập mật khẩu" value={formData.password} onChange={handleChange} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <label className="flex items-center gap-2 cursor-pointer select-none group relative">
                  <div className="relative flex items-center">
                    <input type="checkbox" className="peer w-4 h-4 cursor-pointer appearance-none rounded border border-gray-300 checked:!bg-[#2563EB] checked:!border-[#374151] transition-all bg-white focus:ring-0 focus:outline-none" />
                    <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 text-white pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-sm text-[#4B5563] group-hover:text-[#111827] transition-colors">Ghi nhớ tôi</span>
                </label>
                <a href="/forgot-password" style={{ fontSize: '14px', color: '#2563EB', fontWeight: '600', textDecoration: 'none' }}>Quên mật khẩu?</a>
              </div>
              <PrimaryButton isLoading={loading}>Đăng nhập</PrimaryButton>
            </form>
            <div style={{ marginTop: '20px' }}>
              <p style={{ textAlign: 'center', color: '#6B7280', fontSize: '14px', marginBottom: '16px' }}>Hoặc đăng nhập bằng</p>
              <div style={{ display: 'flex', gap: '12px' }}>
                <button type="button" onClick={() => googleLogin()} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '10px', border: '1px solid #E5E7EB', borderRadius: '8px', backgroundColor: 'white', color: '#374151', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5" />
                  Google
                </button>
                <button type="button" style={{ flex: 1, background: '#1877F2', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '500', cursor: 'not-allowed', opacity: 0.7 }}>Facebook</button>
                <button type="button" style={{ flex: 1, background: '#0A66C2', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '500', cursor: 'not-allowed', opacity: 0.7 }}>LinkedIn</button>
              </div>
            </div>
            <div style={{ marginTop: '30px', textAlign: 'center' }}>
              <p style={{ color: '#6B7280', fontSize: '15px' }}>
                Chưa có tài khoản? <span onClick={goRegisterSelect} style={{ color: '#2563EB', fontWeight: '600', cursor: 'pointer' }}>Đăng ký ngay</span>
              </p>
            </div>
          </>
        )}
      </AuthLayout>
    );
  }

  // Màn hình Register
  if (currentStep === 'register' || isVerifying) {
    const isBusiness = selectedRole === 'business';

    return (
      <AuthLayout title={isVerifying ? "Xác thực OTP" : "Đăng ký"} subtitle={isVerifying ? "Vui lòng kiểm tra email" : "Tạo tài khoản mới"}>
        {showExitModal && <ExitModal onConfirm={handleConfirmExit} onCancel={() => setShowExitModal(false)} />}
        <SuccessMessage message={successMsg} />
        <ErrorMessage message={error} />

        {isVerifying ? (
          // ✅ Đã thêm props onKeyDown và onPaste
          <OtpInput value={otp} onChange={handleOtpChange} onKeyDown={handleOtpKeyDown} onPaste={handleOtpPaste} onVerify={handleVerifyOtp} loading={loading} onResend={() => handleSendOtp(verifyEmail)} />
        ) : (
          <form onSubmit={handleRegister}>
            {isBusiness && (
              <>
                <InputField label="Họ và Tên người đại diện" type="text" name="fullName" placeholder="Ví dụ: Nguyễn Văn A" value={formData.fullName} onChange={handleChange} />
                <InputField label="Tên doanh nghiệp" type="text" name="companyName" placeholder="Ví dụ: Công ty TNHH ABC" value={formData.companyName} onChange={handleChange} />
              </>
            )}
            <InputField label="Email" type="email" name="email" placeholder="name@example.com" value={formData.email} onChange={handleChange} />
            <InputField label="Mật khẩu" type="password" name="password" placeholder="Tối thiểu 6 ký tự" value={formData.password} onChange={handleChange} />
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '30px' }}>
              <label className="relative flex items-center mt-1 cursor-pointer">
              <input type="checkbox" required className="peer w-4 h-4 cursor-pointer appearance-none rounded border border-gray-300 checked:!bg-[#2563EB] checked:!border-[#2563EB] transition-all bg-white focus:ring-0 focus:outline-none" />
              <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 text-white pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </label>

              <span style={{ fontSize: '14px', color: '#4B5563', lineHeight: '1.5' }}>
                 Tôi đồng ý với{' '}
                <Link to={`/terms?role=${selectedRole}`} style={{ color: '#2563EB', textDecoration: 'none', fontWeight: '500' }}>Điều khoản dịch vụ</Link>
                {' '}và{' '}
                <Link to={`/privacy?role=${selectedRole}`} style={{ color: '#2563EB', textDecoration: 'none', fontWeight: '500' }}>Chính sách bảo mật</Link> của SkillMatch. <br />
                <span className="text-xs text-gray-500">*Bao gồm việc đồng ý sử dụng Webcam/Microphone cho các bài kiểm tra chống gian lận.</span>
              </span>
            </div>
            <PrimaryButton isLoading={loading}>Tiếp tục</PrimaryButton>
          </form>
        )}

        {!isVerifying && (
          <div style={{ marginTop: '30px', textAlign: 'center' }}>
            <p style={{ color: '#6B7280', fontSize: '15px' }}>
              Đã có tài khoản? <span onClick={goLogin} style={{ color: '#2563EB', fontWeight: '600', cursor: 'pointer' }}>Đăng nhập</span>
            </p>
          </div>
        )}
      </AuthLayout>
    );
  }
}